import React from "react";

export default function FinancialStatementView({ data, preview_url }) {
  if (!data) return null;

  return (
    <>
      {/* Header */}
      <div className="w-full text-left p-3 flex items-center gap-3 bg-[#5a6db3] ">
        <h2 className="text-lg font-semibold">
          Financial Statement Details
        </h2>
      </div>

      {/* Client + Statement Info */}
      <div className="border border-t-0 rounded-b-lg p-4 grid grid-cols-2 gap-6 bg-white shadow">
        <div>
          <h3 className="font-semibold mb-2">Client Information</h3>
          <p><b>Client Name:</b> {data.client_name || "N/A"}</p>
          <p><b>Company Name:</b> {data.company_name || "N/A"}</p>
          <p><b>Filename:</b> {data.filename || "N/A"}</p>
        </div>

        <div>
          <h3 className="font-semibold mb-2">Statement Details</h3>
          <p><b>Period Date:</b> {data.period_date || "N/A"}</p>
          <p><b>Upload Date:</b> {data.upload_date || "N/A"}</p>
        </div>
      </div>

      {/* Financial Summary */}
      {data.financial_summary && (
        <div
          className="mt-4 p-3 border rounded-lg text-black"
          style={{ background: "aliceblue" }}
        >
          <h3 className="font-semibold mb-2">Financial Summary</h3>
          <p><b>Total Assets:</b> {data.financial_summary.total_assets || "N/A"}</p>
          <p><b>Total Liabilities:</b> {data.financial_summary.total_liabilities || "N/A"}</p>
          <p><b>Net Profit:</b> {data.financial_summary.net_profit || "N/A"}</p>
          <p><b>Revenue:</b> {data.financial_summary.revenue || "N/A"}</p>
          <p><b>Expenses:</b> {data.financial_summary.expenses || "N/A"}</p>
        </div>
      )}

      {/* Transactions */}
      {Array.isArray(data.transactions) && data.transactions.length > 0 && (
        <div className="border bg-white shadow mt-6">
          <h3 className="w-full text-left p-3 bg-[#5a6db3] ">
            Transactions
          </h3>

          <div className="overflow-x-auto">
            <table className="w-full border rounded-lg overflow-hidden">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-4 py-2 border text-left">Date</th>
                  <th className="px-4 py-2 border text-left">Description</th>
                  <th className="px-4 py-2 border text-right">Amount</th>
                  <th className="px-4 py-2 border text-right">Category</th>
                </tr>
              </thead>
              <tbody>
                {data.transactions.map((txn, idx) => (
                  <tr key={idx} className="hover:bg-gray-50">
                    <td className="px-4 py-2 border">{txn.date}</td>
                    <td className="px-4 py-2 border">{txn.description}</td>
                    <td
                      className={`px-4 py-2 text-right border ${
                        txn.amount < 0 ? "text-red-600" : "text-green-600"
                      }`}
                    >
                      {txn.amount}
                    </td>
                    <td className="px-4 py-2 text-right border">
                      {txn.category}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* PDF Preview */}
      {preview_url && (
        <div className="mt-6">
          <h3 className="font-semibold mb-2">
            Uploaded Document Preview
          </h3>
          <iframe
            src={preview_url}
            width="100%"
            height="600"
            style={{ border: "1px solid #ccc", borderRadius: "8px" }}
            title="PDF Preview"
          />
        </div>
      )}
    </>
  );
}
